class WebAppsFlyer {
  constructor() {}

  public init = () => {};

  public trackSessionStart = () => {};

  public trackSessionEnd = () => {};

  public trackUserRegistration = () => {};

  public trackAppHomePageView = () => {};

  public trackDemoSignupPageView = () => {};

  public trackDemoSignup = () => {};

  public getStoredDeepLinkData = () => {
    return null;
  };

  public getAttributionData = () => {
    return null;
  };

  public clearDeepLinkData = () => {};

  public subscribe = () => {
    return () => {};
  };
}

export default new WebAppsFlyer();
